// @format

import 'jquery-drawer'

declare global {
  interface JQuery {
    drawer(): JQuery
  }
}

export function initDrawer(): void {
  const $drawer = $('#task-drawer')
  if (!$drawer.length) return

  $drawer.drawer()

  $('#open-drawer').off('click').on('click', function () {
    const default_assigned_to = $(this).data('default-assigned-to') || null

    $drawer.addClass('drawer-open')
    $('body').addClass('no-scroll')

    clearTaskForm(default_assigned_to)
    updateTaskDrawerButtons()
  })

  $drawer.find('.drawer-close').off('click').on('click', () => {
    $drawer.removeClass('drawer-open')
    $('body').removeClass('no-scroll')
  })

  $drawer.find('.drawer-overlay').off('click').on('click', () => {
    $drawer.removeClass('drawer-open')
    $('body').removeClass('no-scroll')
  })

  $(document).off('click', '.edit-task-button').on('click', '.edit-task-button', function (event) {
    event.stopPropagation();
    const taskData = {
      id: $(this).data('id'),
      subject: $(this).data('subject'),
      priority: $(this).data('priority'),
      type: $(this).data('type'),
      status: $(this).data('status'),
      assignedTo: $(this).data('assigned-to'),
      reminder: $(this).data('reminder'),
      dueDate: $(this).data('due-date'),
      dueTime: $(this).data('due-time'),
      notes: $(this).data('notes'),
    }


    populateTaskForm(taskData)
    updateTaskDrawerButtons(true)

    $drawer.addClass('drawer-open')
    $('body').addClass('no-scroll')
  })

  $('#create-task-btn').off('click').on('click', function (e) {
    e.preventDefault()
    const view_type = $('#view-type').val()
    const data = {
      customer_id: new URLSearchParams(window.location.search).get('id') || '',
      title: $('#task-title').val(),
      task_type: $('#task-type').val(),
      priority: $('#task-priority').val(),
      assigned_to: $('#task-assigned-to').val(),
      queue: $('#task-queue').val(),
      reminder: $('#reminder').val(),
      due_date: getDueDateValue(),
      due_time: $('#due-time-options').val(),
      notes: $('#task-notes').summernote('code'),
      view_type: view_type
    }

    if (!validateTaskData(data)) return

    const $drawerNav = $('.drawer-nav')
    const $drawerOverlay = $('.drawer-overlay')

    $.ajax({
      url: '/customer_success/create_task',
      method: 'POST',
      data: data,
      beforeSend: function () {
        $drawerNav.css({ 'pointer-events': 'none', 'opacity': 0.9 })
        $drawerOverlay.css({ 'pointer-events': 'none' })

        if ($drawerNav.find('.ajax-loading-spinner').length === 0) {
          const spinner = $(`
            <div class="ajax-loading-spinner">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          `)

          $drawerNav.append(spinner)
        }
      },
      success: function (response) {
        if (response.success) {
          if (view_type == "task_row") {
            if (response.show_in_list) {
              $('.my-tasks-table tbody').prepend(response.task_html)
            }
          } else if (view_type == "task_item") {
            addTaskHtmlToList(response.task_html)
          }
          $drawer.removeClass('drawer-open')
          $('body').removeClass('no-scroll')
          $('#flash-container').html(response.flash)
        } else {
          location.reload()
        }
      },
      error: function (xhr) {
        console.error('Failed to create task', xhr.responseText)
        $('#flash-container').html(xhr.responseJSON.flash)
      },
      complete: function () {
        $drawerNav.css({ 'pointer-events': '', 'opacity': '' })
        $drawerOverlay.css({ 'pointer-events': '' })
        $drawerNav.find('.ajax-loading-spinner').remove()
        checkTruncation()
      }
    })
  })

  $('#save-task-btn').off('click').on('click', function (e) {
    e.preventDefault()
    const taskId = $('#task-id').val() as string
    const data = {
      id: taskId,
      title: $('#task-title').val(),
      task_type: $('#task-type').val(),
      priority: $('#task-priority').val(),
      assigned_to: $('#task-assigned-to').val(),
      queue: $('#task-queue').val(),
      reminder: $('#reminder').val(),
      due_date: getDueDateValue(),
      due_time: $('#due-time-options').val(),
      notes: $('#task-notes').summernote('code'),
      view_type: $('#view-type').val()
    }

    if (!validateTaskData(data)) return

    const $drawerNav = $('.drawer-nav')
    const $drawerOverlay = $('.drawer-overlay')

    $.ajax({
      url: '/customer_success/update_task',
      method: 'PATCH',
      data: data,
      beforeSend: function () {
        $drawerNav.css({ 'pointer-events': 'none', 'opacity': 0.9 })
        $drawerOverlay.css({ 'pointer-events': 'none' })

        if ($drawerNav.find('.ajax-loading-spinner').length === 0) {
          const spinner = $(`
            <div class="ajax-loading-spinner">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          `)

          $drawerNav.append(spinner)
        }
      },
      success: function (response) {
        if (response.success) {
          if (response.show_in_list) {
            replaceTaskInList(response.task_data.id, response.task_html)
          } else {
            // Task was reassigned away from the current user — remove from this view
            $(`#task-${response.task_data.id}`).remove()
          }
          $('#flash-container').html(response.flash)
          $drawer.removeClass('drawer-open')
          $('body').removeClass('no-scroll')
        } else {
          location.reload()
        }
      },
      error: function (xhr) {
        console.error('Failed to save task', xhr.responseText)
        $('#flash-container').html(xhr.responseJSON.flash)
      },
      complete: function () {
        $drawerNav.css({ 'pointer-events': '', 'opacity': '' })
        $drawerOverlay.css({ 'pointer-events': '' })
        $drawerNav.find('.ajax-loading-spinner').remove()
        checkTruncation()
      }
    })
  })

  $('#cancel-task-btn').off('click').on('click', () => {
    $drawer.removeClass('drawer-open')
  })

  $('#delete-task-btn').off('click').on('click', function () {
    const taskId = $(this).data('task-id')

    $('#delete-task-id').val(taskId)
    $('#deleteTaskModal').modal('show')
  })

  $(document).ready(function() {
    checkTruncation();
    initDueDate();
  });

  let resizeTimer: ReturnType<typeof setTimeout>

  const resizeObserver = new (window as any).ResizeObserver(() => {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(() => {
      checkTruncation()
    }, 150)
  })

  const $table = $('.my-tasks-table')
  if ($table.length) {
    resizeObserver.observe($table[0])
  }


  function checkTruncation() {
    $('.task-subject, .task-body').each(function() {
      const $icon = $(this).next('.view-full-data')

      const isTruncated = this.scrollWidth > this.offsetWidth || this.scrollHeight > this.offsetHeight
      const hasImage = $(this).find('img').length > 0
      if (hasImage && !isTruncated) $(this).addClass('has-hidden-image')

      isTruncated || hasImage ? $icon.show() : $icon.hide()
    });

    $('.view-full-data').off('click').on('click', (event) => {
      event.stopPropagation();
      const target = event.currentTarget as HTMLElement;
      const content = target.getAttribute('data-content');
      const title = target.getAttribute('data-title');
      const modal = $('#fullContentModal');
      const modalTitle = modal.find('[data-modal-target="title"]');
      const modalContent = modal.find('[data-modal-target="content"]');
      modalTitle.text(title);
      const decoded = $('<textarea>').html(content).text();
      modalContent.html(decoded);
      modal.modal('show');
    });
  }

}

function replaceTaskInList(taskId: string, taskHtml: string) {
  const $oldTask = $(`#task-${taskId}`)
  
  if ($oldTask.length === 0) {
    console.warn('Task not found, reloading')
    location.reload()
    return
  }
  
  const $newTask = $(taskHtml)
  $oldTask.replaceWith($newTask)
}

function addTaskHtmlToList(taskHtml: string) {
  const $newTask = $(taskHtml)
  let $upcomingSection = $('.card:has(h6:contains("Upcoming"))')
  if ($upcomingSection.length === 0) {
    $upcomingSection = $(`
      <div class="mt-4 card p-4" style="border-radius: 8px;">
        <h6 class="text-muted mb-3">Upcoming</h6>
      </div>
    `)
    
    $('.tasks-header').after($upcomingSection)
  }
  const $children = $upcomingSection.children()

  if ($children.length > 1) {
    $children.eq(1).before($newTask)
  } else {
    $upcomingSection.append($newTask)
  }
}

function clearTaskForm(default_assigned_to: string | null) {
  $('#task-title').val('')
  $('#task-type').val('TODO')
  $('#task-priority').val('NONE')
  $('#task-queue').val('')
  $('#due-date-options').val('').show()
  $('#due-date-custom').val('').hide()
  $('#due-time-options').val('')
  $('#reminder').val('')
  $('#task-notes').summernote('code', '')
  const $select = $('#task-assigned-to');
  const value = default_assigned_to;

  $select.val(
    $select.find(`option[value="${value}"]`).length
      ? value
      : 'viktor@intro.io'
  );
}

function populateTaskForm(data: any) {
  $('#task-id').val(data.id)
  $('#task-title').val(data.subject)
  $('#task-type').val(data.type || 'TODO')
  $('#task-priority').val(data.priority || 'NONE')
  $('#task-assigned-to').val(data.assignedTo || 'viktor@intro.io')
  $('#task-queue').val(data.queue || '')
  $('#due-time-options').val(data.dueTime?.split('T')[0] || '')
  $('#reminder').val(data.reminder || '')
  $('#task-notes').summernote('code', data.notes || '')

  const dueDateValue = data.dueDate?.split('T')[0] || ''
  const $dateSelect = $('#due-date-options')
  const $dateCustom = $('#due-date-custom')

  const existsInOptions = dueDateValue &&
    $dateSelect.find('option').toArray().some(opt => $(opt).val() === dueDateValue)

  if (existsInOptions) {
    $dateSelect.val(dueDateValue).show()
    $dateCustom.val(dueDateValue).hide()
  } else if (dueDateValue) {
    $dateSelect.val('custom').hide()
    $dateCustom.val(dueDateValue).show()
  } else {
    $dateSelect.val('').show()
    $dateCustom.val('').hide()
  }
}

function updateTaskDrawerButtons(isEditMode = false) {
  if (isEditMode) {
    $('#create-task-btn').addClass('d-none').prop('disabled', true)
    $('#save-task-btn, #cancel-task-btn, #delete-task-btn').removeClass('d-none').prop('disabled', false)
    $('#delete-task-btn').attr('data-task-id', $('#task-id').val() as string)
  } else {
    $('#create-task-btn').removeClass('d-none').prop('disabled', false)
    $('#save-task-btn, #cancel-task-btn, #delete-task-btn').addClass('d-none').prop('disabled', true)
  }


  $('#task-form').off('keydown').on('keydown', function(e) {
    if (e.which === 13 && !$(e.target).is('.note-editable')) { // Enter key, but not in textarea
      e.preventDefault()
      
      // Check which mode we're in and trigger the appropriate button
      if ($('#save-task-btn').is(':visible') && !$('#save-task-btn').hasClass('d-none')) {
        $('#save-task-btn').trigger('click')
      } else if ($('#create-task-btn').is(':visible') && !$('#create-task-btn').hasClass('d-none')) {
        $('#create-task-btn').trigger('click')
      }
      
      return false
    }
  })
}

function initDueDate() {
  const $dateSelect = $('#due-date-options')
  const $dateCustom = $('#due-date-custom')

  if (!$dateSelect.length) return

  $dateSelect.empty()

  const today = new Date()

  const options = [
    { label: "Today", date: today },
    { label: "Tomorrow", date: addDays(today, 1) },
    { label: "In 1 business day", date: addBusinessDays(today, 1) },
    { label: "In 2 business days", date: addBusinessDays(today, 2) },
    { label: "In 3 business days", date: addBusinessDays(today, 3) },
    { label: "In 1 week", date: addDays(today, 7) },
    { label: "In 2 weeks", date: addDays(today, 14) },
    { label: "In 1 month", date: addDays(today, 30) },
  ]

  options.forEach(option => {
    const formattedDate = option.date.toLocaleDateString(undefined, {
      weekday: 'long',
      month: 'short',
      day: 'numeric'
    })
    $dateSelect.append(
      $('<option>')
        .val(option.date.toISOString().split('T')[0])
        .text(`${option.label} (${formattedDate})`)
    )
  })

  $dateSelect.append(
    $('<option>').val('custom').text('Custom date')
  )

  $dateSelect.off('change').on('change', () => {
    if ($dateSelect.val() === 'custom') {
      $dateSelect.hide()
      $dateCustom.show()

      setTimeout(() => {
        try {
          ($dateCustom[0] as any).showPicker()
        } catch (e) {
          $dateCustom.focus()
        }
      }, 50)
    } else {
      $dateCustom.hide()
      $dateSelect.show()
    }
  })

  function addDays(date: Date, days: number): Date {
    const result = new Date(date)
    result.setDate(result.getDate() + days)
    return result
  }

  function addBusinessDays(date: Date, days: number): Date {
    const result = new Date(date)
    while (days > 0) {
      result.setDate(result.getDate() + 1)
      const day = result.getDay()
      if (day !== 0 && day !== 6) { days-- }
    }
    return result
  }

  const $fixedDiv = $('.body-drawer')
  if ($fixedDiv.length) {
    $fixedDiv.off('wheel').on('wheel', (e: JQuery.TriggeredEvent) => {
      e.preventDefault()
      const wheelEvent = e.originalEvent as WheelEvent
      $fixedDiv.scrollTop($fixedDiv.scrollTop()! + wheelEvent.deltaY)
    })
  }
}

function getDueDateValue(): string {
  const $dateSelect = $('#due-date-options')
  const $dateCustom = $('#due-date-custom')

  if ($dateSelect.val() === 'custom') {
    return $dateCustom.val() as string
  }
  return $dateSelect.val() as string
}
function validateTaskData(data) {
  if (!data.title) {
    alert('Title is required')
    return false
  }
  if (!data.task_type) {
    alert('Task Type is required')
    return false
  }
  if (!data.priority) {
    alert('Priority is required')
    return false
  }
  if (!data.due_date) {
    alert('Due Date is required')
    return false
  }
  if (!data.due_time) {
    alert('Due Time is required')
    return false
  }
  return true
}